import { useTranslation } from 'react-i18next'
import { utcToZonedTime } from 'date-fns-tz'
import { isValid } from 'date-fns'

import { useField } from 'formik'
import {
  Box,
  InputAdornment,
  TextField,
  TextFieldProps,
  Typography,
} from '@mui/material'
import { Today } from '@mui/icons-material'

import { DateTimePickerComponent } from '@/views/components'
import { TimeZoneType, TimeZoneUTCType } from '@/enums'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

type PickerType = {
  id: string
  label: string
  minDateTime: Date
  value: string | Date
  isVisible: boolean
}

const textField = (
  params: TextFieldProps,
  item: PickerType,
  timezone: TimeZoneType,
) => (
  <TextField
    {...params}
    sx={{
      width: 265,
      flexShrink: 1,
      '& .MuiInputBase-root:hover': {
        cursor: 'pointer',
      },
    }}
    // error={!!item.error}
    // helperText={item.error}
    InputProps={{
      ...params.InputProps,
      endAdornment: (
        <InputAdornment position="end" sx={{ gap: 1 }}>
          <Typography variant="body2">{timezone?.slice(0, 6)}</Typography>
          <Today fontSize="small" />
        </InputAdornment>
      ),
    }}
  />
)

export const SportsRODateRangeFilterType = ({ handleChangeSearch }: Props) => {
  const { t } = useTranslation()

  const [fieldStartDate] = useField('startDate')
  const [fieldEndDate] = useField('endDate')

  const todayZoned = utcToZonedTime(
    new Date(),
    TimeZoneUTCType[TimeZoneType.GMT_5],
  )

  const pickers: PickerType[] = [
    {
      id: 'startDate',
      label: t('labels.startDate'),
      minDateTime: todayZoned,
      value: fieldStartDate.value,
      isVisible: true,
    },
    {
      id: 'endDate',
      label: t('labels.endDate'),
      minDateTime: fieldStartDate.value
        ? new Date(fieldStartDate.value)
        : todayZoned,
      value: fieldEndDate.value,
      isVisible: true,
    },
  ]

  return (
    <Box mt="8px" ml="16px" display="flex" gap={2} flexWrap="wrap">
      {pickers
        .filter((item) => item.isVisible)
        .map((item) => (
          <DateTimePickerComponent
            key={item.id}
            label={item.label}
            onChange={(newDate) =>
              handleChangeSearch(item.id, isValid(newDate) ? newDate : null)
            }
            value={item.value as Date}
            slots={{
              textField: (params) =>
                textField(params, item, TimeZoneType.GMT_5),
            }}
          />
        ))}
    </Box>
  )
}
